import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
    IAlert,
    NotificationState,
} from '@models';
import {
    ODataQueryOptions,
} from '@services/generics/odata.query';
import { ODataService } from '@services/generics/odata.service';
import { MapperService } from '@services/mapper.service';

import {
    Observable,
    Subject,
} from 'rxjs';
import { map } from 'rxjs/operators';

export enum NotificationSeverity {
    Info,
    Success,
    Warn,
    Error,
    Fatal,
}

@Injectable()
export class AlertsService extends ODataService<IAlert, string> {
    public count$: Subject<number> = new Subject();
    protected _endpoint = '/odata/Alerts';
    private _alertCount = 0;

    constructor(http: HttpClient) {
        super(http, MapperService.alertMap);
    }

    public getUnreadCount(): Observable<number> {
        return this._http.get(`${this._endpoint}/UiPath.Server.Configuration.OData.GetUnreadCount`)
            .pipe(
                map((res: any) => {
                    const count = res.value;
                    this._alertCount = count;
                    return count;
                }),
            );
    }

    public markAsRead(ids: Array<string>): Observable<any> {
        const payload = { ids };
        return this._http.post(`${this._endpoint}/UiPath.Server.Configuration.OData.MarkAsRead`, payload)
            .pipe(
                map((res: any) => {
                    const count = res.value;
                    this._alertCount = count;
                    this.count$.next(count);
                }),
            );
    }

    public getUnreadList(top: number) {
        const options: ODataQueryOptions = {
            filter: {
                State: {
                    eq: NotificationState.Unread.toString(),
                },
            },
            top,
            orderBy: ['Severity desc', 'CreationTime desc'],
        };
        return this.get(options);
    }

    public incrementCount() {
        this.count$.next(this._alertCount + 1);
    }
}
